import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { ThemeDefinition, ThemeId } from '../../styles/themes';

type Props = {
  themes: ThemeDefinition[];
  selectedId: ThemeId;
  onSelect: (id: ThemeId) => void;
  compact?: boolean;
};

const ThemePickerGrid: React.FC<Props> = ({ themes: list, selectedId, onSelect, compact }) => (
  <div className={compact ? 'theme-picker theme-picker--compact' : 'theme-picker'}>
    {list.map((t) => (
      <motion.button
        key={t.id}
        type="button"
        className={`theme-picker__card${selectedId === t.id ? ' theme-picker__card--active' : ''}`}
        onClick={() => onSelect(t.id)}
        whileHover={{ scale: 1.02, y: -2 }}
        whileTap={{ scale: 0.98 }}
        aria-pressed={selectedId === t.id}
      >
        {selectedId === t.id && (
          <span className="theme-picker__check">
            <Check size={14} />
          </span>
        )}
        <div className="theme-picker__swatches">
          {t.preview.map((c) => (
            <span key={c} style={{ background: c }} />
          ))}
        </div>
        <div className="theme-picker__name">{t.name}</div>
        {!compact && <div className="theme-picker__desc">{t.description}</div>}
      </motion.button>
    ))}
  </div>
);

export default ThemePickerGrid;
